import { Page } from 'layouts/Page';
import { FC } from 'react';
import { UserManagement } from '../../components/UserManagement';

export const UserManagementPage: FC = () => {
	return (
		<Page title="User Management – EAS Control Center">
			<UserManagement />
		</Page>
	);
};
